import ArtifactGroupType from "../base/ArtifactGroupType";


const TrojanHorseHead = {
  id: '145',
  name: "Trojan Horse's Head",
  groupIcon: 'LegendsOfTroy',
  type: ArtifactGroupType.LEGENDS_OF_TROY,
  icon: 'HeadOfTheTrojanHorse',
  power: 50,
  gameId: 'HeadOfTheTrojanHorse'
};

export default TrojanHorseHead;
